<template>
  <v-data-table
    :headers="headers"
    :hide-default-header="true"
    :hide-default-footer="true"
    :items="kvItems"
    item-key="key"
    no-data-text="无相关信息"
  >
    <template #[`item.value`]="{ item }">
      <span v-if="item.type == 'link'">
        <v-icon class="pr-2 d-none d-sm-inline">mdi-link</v-icon>
        <a
          :href="item.value"
          target="_blank"
          rel="noopener noreferer"
          v-html="item.value"
        ></a>
      </span>
      <span v-else-if="item.type == 'date'">{{
        dateTimeToString(item.value)
      }}</span>
      <span v-else>{{ item.value }}</span>
    </template>
  </v-data-table>
</template>

<script>
import toDateString from "@/mixins/toDateString";
const headers = [
  {
    value: "title",
  },
  {
    value: "value",
  },
];
export default {
  props: ["meta", "metaDesc"],
  mixins: [toDateString],
  data: () => ({
    headers,
  }),
  computed: {
    kvItems() {
      let meta = this.meta || {};
      return this.metaDesc
        .map((kvItem) => {
          if (kvItem.key in meta) {
            return {
              ...kvItem,
              value: meta[kvItem.key],
            };
          } else if (kvItem.value) {
            return kvItem;
          }
        })
        .filter((kvItem) => kvItem != null);
    },
  },
  methods: {},
};
</script>